import { render } from "./GameSchedules.vue?vue&type=template&id=b0c52992&scoped=true"
import script from "./GameSchedules.vue?vue&type=script&scoped=true&lang=js"
export * from "./GameSchedules.vue?vue&type=script&scoped=true&lang=js"

import "./GameSchedules.vue?vue&type=style&index=0&id=b0c52992&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c52992"]])

export default __exports__